import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Text, TextInput, View } from 'react-native';
import MinusIcon from '@/assets/icon/ic_minus.svg';
import PlusIcon from '@/assets/icon/ic_plus.svg';
import PressableChip from '@/components/PressableChip';
import { SccPressable } from '@/components/SccPressable';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
export default function FloorSelect({ value, onChange, minAbsoluteFloor = 1, }) {
    const [sign, setSign] = useState(value !== undefined ? value > 0 : true);
    const initialFloor = value
        ? Math.max(Math.abs(value), minAbsoluteFloor)
        : minAbsoluteFloor;
    const [floor, setFloor] = useState(String(initialFloor));
    useEffect(() => {
        if (sign) {
            onChange(Number(floor));
        }
        else {
            onChange(-Number(floor));
        }
    }, [sign, floor]);
    // 지상이면 minAbsoluteFloor 적용, 지하면 항상 1부터
    const effectiveMin = sign ? minAbsoluteFloor : 1;
    const numFloor = Number(floor);
    const isDecreaseDisabled = numFloor <= effectiveMin;
    function increase() {
        setFloor(String(numFloor + 1));
    }
    function decrease() {
        if (numFloor <= effectiveMin) {
            return;
        }
        setFloor(String(numFloor - 1));
    }
    return (_jsxs(View, { className: "flex-row items-center gap-5", children: [_jsxs(View, { className: "flex-row gap-2", children: [_jsx(PressableChip, { label: "\uC9C0\uC0C1", active: sign, onPress: () => setSign(true) }), _jsx(PressableChip, { label: "\uC9C0\uD558", active: !sign, onPress: () => setSign(false) })] }), _jsxs(View, { className: "flex-1 flex-row items-center gap-1.5", children: [_jsxs(View, { className: "flex-1 max-w-[140px] h-12 border border-[#DCDEE3] rounded-xl overflow-hidden", children: [_jsx(SccPressable, { elementName: "floor_select_decrease_button", onPress: decrease, disabled: isDecreaseDisabled, style: {
                                    position: 'absolute',
                                    zIndex: 1,
                                    left: 0,
                                    top: '50%',
                                    transform: 'translateY(-20px)',
                                    backgroundColor: '#F7F7F9',
                                    width: 36,
                                    height: 40,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    opacity: isDecreaseDisabled ? 0.3 : 1,
                                }, children: _jsx(MinusIcon, { width: 16, color: '#383841' }) }), _jsx(TextInput, { keyboardType: "number-pad", value: floor, onChangeText: setFloor, placeholder: "1", textAlign: "center", style: {
                                    color: color.black,
                                    fontSize: 16,
                                    fontFamily: font.pretendardRegular,
                                    paddingVertical: 0,
                                    height: 40,
                                } }), _jsx(SccPressable, { elementName: "floor_select_increase_button", onPress: increase, style: {
                                    position: 'absolute',
                                    zIndex: 1,
                                    right: 0,
                                    top: '50%',
                                    transform: 'translateY(-20px)',
                                    backgroundColor: '#F7F7F9',
                                    width: 36,
                                    height: 40,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }, children: _jsx(PlusIcon, { width: 16, color: '#383841' }) })] }), _jsx(Text, { className: "font-pretendard-medium text-[15px] leading-[22px]", children: "\uCE35" })] })] }));
}
